const page = (label, to, options = {}) => ({ label, to, ...options });
const meetingsGroup = () => ({ label: 'Sales Meetings', pages: [page('Meeting Calendar', '/meetings')] });

export function navigationGroups(user, salespeople = []) {
  const role = user?.role;
  const staff = role === 'superadmin' || role === 'admin';
  const superadmin = role === 'superadmin';
  if (staff) {
    const guides = salespeople.filter(person => ['Ginny', 'Zac'].includes(person.name));
    return [
      { label: 'Overview', pages: [page('Dashboard', '/'), page('Data Checks', '/overview/checks'), page('Customer Balances', '/overview/customers'), page('Supplier Balances', '/overview/suppliers')] },
      { label: 'Sales', pages: [
        page('Overview', '/analytics'),
        page('Team', '/sales/team', { paths: ['/jq-bookings', '/zen-bookings'], prefixes: ['/salesperson/'] }),
        page('Commissions', '/commissions', { paths: ['/commission-control'] }),
      ] },
      meetingsGroup(),
      { label: 'Finance', pages: [
        page('P&L Summary', '/pnl'), page('Detailed P&L', '/pnl/detailed'), page('Comparison', '/pnl/compare'), page('Target vs Actual', '/forecast'),
        ...(superadmin ? [page('W Factory', '/wf-report')] : []),
      ] },
      { label: 'Marketing', pages: superadmin ? [
        page('Lead Report', '/marketing'), page('Key in Lead', '/marketing/leads'),
        page('Spend Report', '/marketing/spend-report'), page('Key in Spend', '/marketing/spend'), page('KPI Insert', '/marketing/kpi'),
      ] : [page('KPI Insert', '/marketing/kpi')] },
      { label: 'Reports', prefixes: ['/commission-guide/', '/sales-breakdown/'], pages: [
        page('JQ Commission', '/jq-commission'), page('Zen Commission', '/zen-commission'), ...guides.map(person => page(`${person.name} Commission`, `/commission-guide/${person.id}`)),
        ...guides.map(person => page(`${person.name} Invoices`, `/sales-breakdown/${person.id}`)),
      ] },
      { label: 'Settings', pages: [
        ...(superadmin ? [page('Actuals Input', '/settings/actuals'), page('Forecast Settings', '/settings/daily-forecast'), page('Month Closing', '/settings/month-closing'), page('Bank Accounts', '/settings/bank-accounts'), page('Bonus Gate', '/bonus'), page('Users & Roles', '/settings/users'), page('API Connections', '/settings/api')] : []),
        page('Sync Status', '/sync'), page('Change Password', '/change-password'),
      ] },
    ];
  }
  if (role === 'marketing' || role === 'sales_admin') {
    return [
      { label: 'Marketing', pages: [page('Key in Lead', '/marketing/leads'), ...(role === 'marketing' ? [page('Lead Report', '/marketing'), page('Key in Spend', '/marketing/spend'), page('Spend Report', '/marketing/spend-report')] : [])] },
      { label: 'Settings', pages: [page('Change Password', '/change-password')] },
    ];
  }
  const name = (user?.salesperson_name || user?.name || '').trim().toLowerCase();
  const pages = [];
  if (user?.salesperson_id && user.name !== 'JQ') pages.push(page('My Commission', `/salesperson/${user.salesperson_id}`));
  if (['jq', 'zen'].includes(name)) pages.push(page('My Bookings', `/${name}-bookings`));
  if (name === 'jq') pages.push(page('Commission Guide', '/jq-commission'));
  if (name === 'zen') pages.push(page('Commission Guide', '/zen-commission'));
  if (user?.salesperson_id && ['zac', 'ginny'].includes(name)) {
    pages.push(page('Commission Guide', `/commission-guide/${user.salesperson_id}`), page('Sales Breakdown', `/sales-breakdown/${user.salesperson_id}`));
  }
  return [
    ...(pages.length ? [{ label: 'Sales', pages }] : []),
    meetingsGroup(),
    { label: 'Settings', pages: [page('Change Password', '/change-password')] },
  ];
}

export function activeNavigation(groups, pathname) {
  let match;
  for (const group of groups) {
    for (const page of group.pages) {
      const matches = pathname === page.to
        || (page.to !== '/' && pathname.startsWith(`${page.to}/`))
        || page.paths?.includes(pathname)
        || page.prefixes?.some(prefix => pathname.startsWith(prefix));
      if (matches) {
        if (!match || page.to.length > match.page.to.length) match = { group, page };
      }
    }
  }
  if (match) return match;
  const group = groups.find(group => group.prefixes?.some(prefix => pathname.startsWith(prefix))) || groups[0];
  return { group, page: null };
}
